// // utils/permissions.ts

// type PrivilegeAccess = Record<string, boolean>;

// export interface PermissionMap {
//   [permissionName: string]: PrivilegeAccess;
// }

// /**
//  * Transforms the rolePrivileges array into a flat lookup map.
//  * e.g. { "Dashboard": { read: true }, "Users": { read: true, create: false, ... } }
//  */
// export function buildPermissionMap(user: any): PermissionMap {
//   const rolePrivileges = user?.role?.rolePrivileges ?? [];

//   return rolePrivileges.reduce((acc: PermissionMap, rp: any) => {
//     const permissionName = rp?.privilege?.permissions;
//     const updatedAccess: PrivilegeAccess = rp?.updatedAccess ?? {};
//     if (permissionName) {
//       acc[permissionName] = updatedAccess;
//     }
//     return acc;
//   }, {});
// }

// /**
//  * Returns true if ANY action in updatedAccess is true for that permission.
//  * This decides whether to SHOW the sidebar item.
//  */
// export function hasAnyAccess(map: PermissionMap, permissionName: string): boolean {
//   const access = map[permissionName];
//   if (!access) return false;
//   return Object.values(access).some(Boolean);
// }

// /**
//  * Returns true/false for a specific action.
//  * Use this to enable/disable buttons inside a section.
//  */
// export function can(map: PermissionMap, permissionName: string, action: string): boolean {
//   return !!map[permissionName]?.[action];
// }

// // Ordered list — first match wins
// const ROUTE_PRIORITY = [
//   { permissionKey: 'Dashboard', href: '/dashboard' },
//   { permissionKey: 'Users', href: `/members/4` },
//   { permissionKey: 'RiskManagement', href: '/risk' },
//   { permissionKey: 'MyReport', href: '/bet-list' },
//   { permissionKey: 'EventManagement', href: '/event-management' },
//   { permissionKey: 'CasinoControl', href: '/casino-management' },
//   { permissionKey: 'Transaction', href: '/requests' },
//   { permissionKey: 'ContentManagement', href: '/content-management' },
//   { permissionKey: 'Bonus', href: '/bonus/policy-management' },
//   { permissionKey: 'Roles Privileges', href: '/roles-and-privileges' },
//   { permissionKey: 'Account Statement', href: '/account-statement' },
//   { permissionKey: 'Change Password', href: '/settings' },
//   { permissionKey: 'Operation logs', href: '/operation-logs' },
// ];

// export function getDefaultRoute(user: any, isOwner: boolean): string {
//   // Owner gets dashboard always
//   if (isOwner) return '/dashboard';
//   const permissionMap = buildPermissionMap(user);

//   const firstAllowed = ROUTE_PRIORITY.find((route) =>
//     hasAnyAccess(permissionMap, route.permissionKey)
//   );

//   // Fallback if somehow nothing is allowed
//   return firstAllowed?.href ?? '/dashboard';
// }

// utils/permissions.ts

type PrivilegeAccess = Record<string, boolean>;

export interface PermissionMap {
  [permissionName: string]: PrivilegeAccess;
}

export function buildPermissionMap(user: any): PermissionMap {
  const rolePrivileges = user?.role?.rolePrivileges ?? [];

  return rolePrivileges.reduce((acc: PermissionMap, rp: any) => {
    const permissionName = rp?.privilege?.permissions;
    const updatedAccess: PrivilegeAccess = rp?.updatedAccess ?? {};

    if (permissionName) {
      acc[permissionName] = updatedAccess;
    }

    return acc;
  }, {});
}

export function hasAnyAccess(map: PermissionMap, permissionName: string): boolean {
  const access = map[permissionName];
  if (!access) return false;
  return Object.values(access).some(Boolean);
}

export function can(map: PermissionMap, permissionName: string, action: string): boolean {
  return !!map[permissionName]?.[action];
}

// New helper
export function hasReadAccess(map: PermissionMap, permissionName: string): boolean {
  return !!map[permissionName]?.read;
}

// Ordered list — first match wins
const ROUTE_PRIORITY = [
  { permissionKey: 'Dashboard', href: '/dashboard' },
  { permissionKey: 'Users', href: `/members/4` },
  { permissionKey: 'RiskManagement', href: '/risk' },
  { permissionKey: 'MyReport', href: '/bet-list' },
  { permissionKey: 'EventManagement', href: '/event-management' },
  { permissionKey: 'CasinoControl', href: '/casino-management' },
  { permissionKey: 'Transaction', href: '/requests' },
  { permissionKey: 'ContentManagement', href: '/content-management' },
  { permissionKey: 'Bonus', href: '/bonus/policy-management' },
  { permissionKey: 'Roles Privileges', href: '/roles-and-privileges' },
  { permissionKey: 'Account Statement', href: '/account-statement' },
  { permissionKey: 'Commission Settings', href: '/commission-setting' },
  { permissionKey: 'Change Password', href: '/settings' },
  { permissionKey: 'Operation logs', href: '/operation-logs' },
];

export function getDefaultRoute(user: any, isOwner: boolean): string {
  if (isOwner) return '/dashboard';

  const permissionMap = buildPermissionMap(user);

  const firstAllowed = ROUTE_PRIORITY.find((route) =>
    hasReadAccess(permissionMap, route.permissionKey)
  );

  return firstAllowed?.href ?? '/dashboard';
}
